module.exports = __webpack_public_path__ + "static/media/closeIcon.c2b579c6.svg";